import { render, staticRenderFns } from "./TakeOut.vue?vue&type=template&id=53dce1fb"
import script from "./TakeOut.vue?vue&type=script&lang=js"
export * from "./TakeOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports